import { commonTranslationKeys } from '@dreryk/react-common';
import { ActionBar, ButtonVariant } from '@dreryk/react-components';

import { NfzLoginFormController } from './NfzLoginForm.types';
import { useCurrentPractitionerUpdateEwusPasswordCommand } from './NfzNewPasswordSaveAction.hooks';
import { PasswordChangeEnabledFormBeanPart } from './fields/PasswordChangeEnabledField';
import { EwusEnabledFormBeanPart } from './fields/EwusEnabledField';

type EwusNewPasswordSaveActionProps = Pick<
   NfzLoginFormController<PasswordChangeEnabledFormBeanPart<true> & EwusEnabledFormBeanPart<true>>,
   'handleSubmit'
> & { onSuccess: VoidFunction };

export const EwusNewPasswordSaveAction = (props: EwusNewPasswordSaveActionProps): JSX.Element => {
   const { executeAsync: updatePractitionerEwusConfiguration } = useCurrentPractitionerUpdateEwusPasswordCommand({
      onSuccess: props.onSuccess,
   });

   return (
      <ActionBar.PrimaryButton
         testId={'nfzChangePassword'}
         label={commonTranslationKeys.save}
         onClick={props.handleSubmit(updatePractitionerEwusConfiguration)}
         variant={ButtonVariant.PRIMARY}
         order={1}
      />
   );
};
